module.exports = __webpack_public_path__ + "static/media/mountains.8235c4b8.png";